import { t } from '@shared/helpers/translation';
import {
    ServicePackageType,
    UpSellAddonServicePackage,
} from '@/api/MyBookingSession/myBookingSession.interfaces';
import {
    ServicePackage,
    ServicePackageName,
} from '@ui/components/ServicePackage/ServicePackage.interfaces';
import { getMoneyObjectAsString } from '@shared/helpers/money';
import { RECOMMENDED_SERVICE_PACKAGE } from '@/components/checkoutPageV3/Sections/ServicePackage/ServicePackage.config';

export function getServicePackageContent(addon: UpSellAddonServicePackage): ServicePackage {
    const basePackage = {
        price: addon.Price ?? { Amount: 0, Currency: '' },
        link: '', // add some kind of link
        isRecommended: false,
    };

    let servicePackage: ServicePackage | null;

    switch (addon.PackageType) {
        case ServicePackageType.Basic:
            servicePackage = {
                ...basePackage,
                name: ServicePackageName.Basic,
                title: t({ key: 'service_package.basic_service_package' }),
                usps: [
                    {
                        title: t({ key: 'service_package.usp_priority_title' }),
                        text: t({ key: 'service_package.usp_priority' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_hotel_voucher_title' }),
                        text: t({ key: 'service_package.usp_hotel_voucher' }),
                        badgePrice: getBadgePrice(addon),
                        showBadge: true,
                        badgeColor: 'green',
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_compensation_support_title' }),
                        text: t({ key: 'service_package.usp_compensation_support' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                ],
            };
            break;

        case ServicePackageType.Premium:
            servicePackage = {
                ...basePackage,
                name: ServicePackageName.Premium,
                title: t({ key: 'service_package.premium_service_package' }),
                usps: [
                    {
                        title: t({ key: 'service_package.usp_priority_title' }),
                        text: t({ key: 'service_package.usp_priority' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_hotel_voucher_title' }),
                        text: t({ key: 'service_package.usp_hotel_voucher' }),
                        showBadge: true,
                        badgeColor: 'green',
                        badgePrice: getBadgePrice(addon),
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_compensation_support_title' }),
                        text: t({ key: 'service_package.usp_compensation_support' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_sms_title' }),
                        text: t({ key: 'service_package.usp_sms' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                ],
            };
            break;

        default:
            servicePackage = {
                ...basePackage,
                name: ServicePackageName.None,
                title: '',
                usps: [],
            };
    }
    return {
        ...servicePackage!,
        isRecommended: servicePackage.name === RECOMMENDED_SERVICE_PACKAGE,
    };
}

// Is this really correct?
function getBadgePrice(addon: UpSellAddonServicePackage): string {
    if (!addon.Price) return '';
    return getMoneyObjectAsString(addon.Price);
}
